import { useEffect, useState } from "react";
import { ColumnItem } from "../../common/models/table";
import { StorageService } from "./core/_request";
import { useStorageHistoryStore } from "./store/StorageHistoryStore";
import { HttpStatusCode } from "axios";
import { Loader } from "../../common/components/Loader/Loader";
import { LFTableV3 } from "../../common/components/LFTable/LFTableV3";
import { useQueryStorageLoadState } from "./core/_hooks";
import { useLocation } from "react-router";
import { TitleHeader } from "../../common/components/TitleHeader/TitleHeader";

export const StorageHistory = () => {
  const { pathname } = useLocation();

  const isStorage = pathname.includes('/storage');
  const isContainerYard = pathname.includes('/container-yard');

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { data: storageLoadState, isLoading: storageLoadStateLoader } =
    useQueryStorageLoadState();
  const {
    list,
    pageState,
    resetPageState,
    setActioned,
    setPageState,
    totalItems,
    setList,
  } = useStorageHistoryStore();

  const cols: ColumnItem[] = [
    {
      key: "storage",
      title: "Entrepôt",
      dataIndex: "storage",
      show: true,

      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
    {
      key: "operationLoad",
      title: "Marchandises",
      dataIndex: "operationLoad",
      show: true,
      searchType: "text",
      searchKey: "operationLoad.storageLoads.uniqueIdentifierLoad",

      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.uniqueIdentifier}</span>
          </div>
        );
      },
    },
    {
      key: "state",
      title: "Type de mouvement",
      dataIndex: "state",
      show: true,
      searchType: "select",
      searchKey: "state",
      nestedKey: "state",
      isLoading: storageLoadStateLoader,
      searchOptions: storageLoadState,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
    {
      key: "tonnage",
      title: "Tonnage",
      dataIndex: "tonnage",
      show: true,
    },
    {
      key: "createdAt",
      title: "Date",
      dataIndex: "createdAt",
      show: true,
    },
  ];

  useEffect(() => {
    fetchAllStorageHistory({
      ...pageState,
    });

    return () => {
      setActioned({
        action: "no",
        data: null,
      });
    };
  }, [pageState]);

  const fetchAllStorageHistory = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = isStorage ? await StorageService.getStoreStorageHistoryList({...params,}) : await StorageService.getOpenStorageHistoryList({...params,});

      if (res?.status === HttpStatusCode.Ok) {
        setList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  return (
    <div>
      <TitleHeader
                      title={
                        isStorage
                          ? "Historique des magasins"
                          : "Historique des terres pleins"
                      }
                    />
      <Loader isLoading={isLoading} />

      <div className="mt-4">
        <LFTableV3
          columns={cols}
          data={list}
          params={pageState}
          onAction={() => {}}
          onSearch={handleSetParams}
          onSort={handleSetParams}
          onResetSearch={resetPageState}
          pagination={{
            defaultCurrentPage: pageState.page,
            itemsPerPage: pageState?.itemsPerPage,
            totalItems: totalItems,
          }}
          onChangePage={handleSetParams}
        />
      </div>
    </div>
  );
};
